export default __webpack_public_path__ + "static/media/twitter.41f57e83.svg";